import { Fragment } from 'react';
import { t } from '@lingui/core/macro';
import { ChipAction, Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useField } from 'formik';
import { ChipDropdown } from 'shared/domains/common-ui';
import { allowedIntervals } from './allowedIntervals';
import { allowedPropertiesTranslations, intervalTranslations } from './translations';
import { Breakdown } from '../Breakdown';
import { SelectDataPoint } from '../SelectDataPoint';
import { FieldInputContainer } from '../styled';
export function DateHistogramInput(props) {
    const { pathBase, remove, isSubAggregation = false } = props;
    const currentPath = `${pathBase}.dateHistogramInput`;
    const [field, , helpers] = useField(currentPath);
    const handleChangeInterval = (val) => {
        helpers.setValue(Object.assign(Object.assign({}, field.value), { interval: val }));
    };
    return (<Fragment>
      <FieldInputContainer>
        <SelectDataPoint label={t({
            message: 'Date period',
            comment: 'Insights widget form: Date historam field',
        })} selectedValue={allowedPropertiesTranslations(field.value.field)} name={pathBase} action={<ChipAction onClick={remove}>
              <Falcon icon="close"/>
            </ChipAction>}/>

        <ChipDropdown label={t({
            message: 'Config',
            comment: 'Insights: Date histogram interval configuration',
        })} secondary={intervalTranslations(field.value.interval)} appearance="secondary" variant="outline">
          {allowedIntervals().map((interval) => (<Menu.Item key={interval.value} onClick={() => handleChangeInterval(interval.value)}>
              {interval.label}
            </Menu.Item>))}
        </ChipDropdown>
      </FieldInputContainer>
      {!isSubAggregation && <Breakdown pathBase={currentPath}/>}
    </Fragment>);
}
